import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Construction, ArrowLeft, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageContainer } from "@/components/layout/PageContainer";

export function ComingSoonPage() {
  const location = useLocation();

  // Extract page name from path for display
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const pageName = pathSegments[pathSegments.length - 1] || "Page";
  const formattedName = pageName
    .replace(/-/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

  return (
    <PageContainer>
      <div className="min-h-[60vh] flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="text-center max-w-md mx-auto px-4"
        >
          {/* Icon */}
          <motion.div
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.1, type: "spring", stiffness: 200 }}
            className="w-20 h-20 mx-auto mb-6 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shadow-lg shadow-blue-500/20"
          >
            <Construction className="w-10 h-10 text-white" />
          </motion.div>

          {/* Title */}
          <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-2">
            {formattedName}
          </h1>

          {/* Subtitle */}
          <p className="text-gray-500 dark:text-gray-400 mb-8">
            This feature is coming soon. We're working hard to bring you something amazing.
          </p>

          {/* Actions */}
          <div className="flex items-center justify-center gap-3">
            <Button
              variant="outline"
              onClick={() => window.history.back()}
              className="rounded-full"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Go Back
            </Button>
            <Button asChild className="rounded-full">
              <Link to="/">
                <Home className="w-4 h-4 mr-2" />
                Home
              </Link>
            </Button>
          </div>

          {/* Path indicator */}
          <p className="mt-8 text-xs text-gray-400 dark:text-gray-500 font-mono">
            {location.pathname}
          </p>
        </motion.div>
      </div>
    </PageContainer>
  );
}
